import React from 'react';
import PropTypes from 'prop-types';

function CircleDotIcon({ className, fill, width }) {
  return (
    <svg fill="#000000" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" 
      width={width} viewBox="0 0 29.334 29.334"
      xmlSpace="preserve">
    <g>
      <path d="M14.666,0C6.578,0,0,6.58,0,14.667s6.578,14.667,14.666,14.667s14.668-6.58,14.668-14.667S22.754,0,14.666,0z
        M14.666,25.334C8.784,25.334,4,20.549,4,14.667S8.784,4,14.666,4c5.883,0,10.668,4.785,10.668,10.667S20.547,25.334,14.666,25.334
        z M19.332,14.667c0,2.577-2.089,4.667-4.666,4.667c-2.576,0-4.666-2.089-4.666-4.667C10,12.09,12.09,10,14.666,10
        C17.243,10,19.332,12.09,19.332,14.667z"/>
    </g>
    </svg>
  );
}
CircleDotIcon.propTypes = {
  className: PropTypes.string,
  fill: PropTypes.string,
  width: PropTypes.string,
};

CircleDotIcon.defaultProps = {
  fill: '#000000',
  width: '12',
  className: 'icon-circle-dot',
};

export default CircleDotIcon;
